import dummyFunction from '@/lib/utils/dummyFunction';
import { createContext, useState } from 'react';
import type React from 'react';

const IsGoogleDrivePickerOpenContext = createContext<
  [boolean, (isOpen: boolean) => void]
>([false, dummyFunction]);

type IsGoogleDrivePickerOpenContextProviderProps = {
  children: React.ReactNode;
};

export const IsGoogleDrivePickerOpenContextProvider = ({
  children,
}: IsGoogleDrivePickerOpenContextProviderProps) => {
  const [isGoogleDrivePickerOpen, setIsGoogleDrivePickerOpen] = useState(false);

  return (
    <IsGoogleDrivePickerOpenContext.Provider
      value={[isGoogleDrivePickerOpen, setIsGoogleDrivePickerOpen]}
    >
      {children}
    </IsGoogleDrivePickerOpenContext.Provider>
  );
};

export default IsGoogleDrivePickerOpenContext;
